import { FC, memo } from 'react';
import { CallPoolSettings } from '../../components/CallPoolSettings/CallPoolSettings';

export const CallPoolSettingsScreen: FC = memo(() => {
  return <CallPoolSettings />;
});

CallPoolSettingsScreen.displayName = 'CallPoolSettingsScreen';
